import { createResourceStore } from "@/lib/resource";
import { Country } from "country-state-city";

export interface Location {
  id: string;
  address: string;
  city: string;
  region: string;
  postal_code: string;
  country: any;
}

export const getFullLocation = (location: Location) => {
  return [
    location?.city,
    location?.region,
    Country.getCountryByCode(location?.country)?.name,
  ]
    .filter((item) => item != "" && item != undefined)
    .join(" - ");
};

export const useLocation = createResourceStore<Location>("locations");
